import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/internship-applications/approved', config);
};

const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/internship-applications/approved/excel-export', {
        ...config,
        responseType: 'blob'
    });
};

export default {
    getAll,
    excelExport
};
